/**
 * constants/localSyncStatus.ts
 * Local sync status constants for device-local blob storage
 *
 * Provides runtime values for LocalSyncStatus type.
 * Used by StoredImageBlob to track per-device sync state.
 */

import type { LocalSyncStatus } from '@/types/schema/StoredImage';

/**
 * Valid local sync status values for device-local blob storage.
 *
 * - 'pending': Blob exists locally but hasn't been uploaded to remote
 * - 'synced': Blob is synchronized with remote storage
 * - 'failed': Sync attempt failed (will retry on next sync cycle)
 */
export const LOCAL_SYNC_STATUSES = [
  'pending',
  'synced',
  'failed',
] as const satisfies readonly LocalSyncStatus[];
